<template>
  <div class="homeQuotation">
    <!-- <div
      v-if="carouselList[0]"
      class="adsBanner"
      :style="{ background: carouselList[0].background }"
    >
      <el-image :src="carouselList[0].url" fit="cover"></el-image>
    </div> -->
    <div v-if="carouselList[0]" class="carousel">
      <el-carousel
        :autoplay="true"
        :style="{ background: carouselList[0].background }"
      >
        <el-carousel-item v-for="item of carouselList" :key="item.url">
          <el-image
            :src="item.url"
            fit="cover"
            @click="clickCarousel(item)"
          ></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="mainContainer HomeContainer">
      <div class="tableContainer">
        <div class="nowFilter">
          <span style="width: 102px; text-indent: 12px">{{l("当前筛选")}}：</span>
          <div
            v-if="SearchData.category_id"
            class="condition"
            @click="
              SearchData.category_id = null;
              GetTableList(true);
            "
          >
            {{l("品类")}}:
            <span>{{ l($store.getCategoryName(SearchData.category_id)) }}</span>
            <i class="el-icon-close"></i>
          </div>
          <div
            v-if="SearchData.child_category"
            class="condition"
            @click="
              SearchData.child_category = '';
              GetTableList(true);
            "
          >
            {{l("品名")}}:
            <span>{{ l(SearchData.child_category) }}</span>
            <i class="el-icon-close"></i>
          </div>
          <div
            v-if="SearchData.character"
            class="condition"
            @click="
              SearchData.character = null;
              GetTableList(true);
            "
          >
            {{l("品质")}}:
            <span v-if="SearchData.character == 1">{{l("正品现货")}}</span>
            <span v-if="SearchData.character == 2">{{l("二级余料")}}</span>
            <span v-if="SearchData.character == 3">{{l("正品余料")}}</span>
            <i class="el-icon-close"></i>
          </div>

          <div
            v-if="
              SearchData.category_id ||
              SearchData.child_category ||
              SearchData.character
            "
            class="clearAll"
            @click="
              SearchData.category_id = null;
              SearchData.child_category = '';
              SearchData.character = null;
              GetTableList(true);
            "
          >
            {{l("清除筛选")}}
          </div>
          <div v-else>{{l("全部商品")}}</div>
        </div>
        <div class="categoryContainer">
          <div class="line">
            <div class="title">{{l("品类")}}</div>
            <div class="category_list">
              <div
                v-for="category of $store.state.basicInfo.categoryList_quotation"
                :key="category.id"
                :class="{ active: SearchData.category_id == category.id }"
                @click="
                  SearchData.category_id = category.id;
                  SearchData.child_category = '';
                  GetTableList(true);
                "
              >
                {{ l(category.name) }}
              </div>
            </div>
          </div>
          <div class="line" v-if="child_categoryList.length">
            <div class="title">{{l("品名")}}</div>
            <div class="category_list">
              <div
                v-for="child_category of child_categoryList"
                :key="child_category.id"
                :class="{
                  active: SearchData.child_category == child_category.name,
                }"
                @click="
                  SearchData.child_category = child_category.name;
                  GetTableList(true);
                "
              >
                {{ l(child_category.name) }}
              </div>
            </div>
          </div>
          <div class="line">
            <div class="title">{{l("品质")}}</div>
            <div class="category_list">
              <div
                :class="{
                  active: SearchData.character == 1,
                }"
                @click="
                  SearchData.character = 1;
                  GetTableList(true);
                "
              >
                {{l("正品现货")}}
              </div>
              <div
                :class="{
                  active: SearchData.character == 2,
                }"
                @click="
                  SearchData.character = 2;
                  GetTableList(true);
                "
              >
                {{l("二级余料")}}
              </div>
              <div
                :class="{
                  active: SearchData.character == 3,
                }"
                @click="
                  SearchData.character = 3;
                  GetTableList(true);
                "
              >
                {{l("正品余料")}}
              </div>
            </div>
          </div>
        </div>

        <div class="orderContainer">
          <div
            class="orderItem"
            style="width: 84px"
            :class="{ active: !Sorting }"
            @click="
              Sorting = null;
              GetTableList(true);
            "
          >
            {{l("综合")}}
          </div>
          <div
            class="orderItem"
            :class="{ active: Sorting == '-created_time' }"
            @click="
              Sorting = '-created_time';
              GetTableList(true);
            "
          >
            {{l("最新发布")}}<i class="el-icon-top"></i>
          </div>
          <div
            class="orderItem"
            :class="{ active: Sorting == 'cheap_specification_price__price' }"
            @click="
              Sorting = 'cheap_specification_price__price';
              GetTableList(true);
            "
          >
            {{l("价格升序")}}<i class="el-icon-top"></i>
          </div>


          <div class="filterItem">
            <div class="label">{{l("国家/地区")}}</div>
            <el-select v-model="SearchData.country" :placeholder="l('请选择')" @change="SearchData.address='';GetTableList(true)" filterable clearable size="small">
              <el-option v-for="item in $store.state.basicInfo.countryList" :key="item.code" :label="item.cnName+' ('+item.name+')'"
                :value="item.code">
                <span style="float: left">{{item.cnName}}（{{ item.name }}）</span>
                <span style="float: right">
                  <img :src="GetResourceUrl('flags/' + item.code.toLowerCase() + '.png')" style="width:30px;" />
                </span>
              </el-option>
            </el-select>
          </div>

          <div v-show="SearchData.country=='CN'"  class="filterItem">
            <div class="label">{{l("发货地")}}</div>
            <el-cascader
              ref="cascader"
              style="width: 220px"
              size="small"
              v-model="SearchData.address"
              :options="$store.state.basicInfo.cityList"
              :props="{
                expandTrigger: 'hover',
                label: 'name',
                value: 'name',
                children: 'child',
                emitPath: true,
                checkStrictly: true,
              }"
              :placeholder="l('请选择') + l('发货地')"
              filterable
              clearable
              @change="GetTableList(true)"
            >
              <template slot-scope="{ node, data }">
                <div @click="cascaderClick(data)">
                  <span>{{ data.name }}</span>
                  <span v-if="false && !node.isLeaf">
                    ({{ data.child.length }})
                  </span>
                </div>
              </template>
            </el-cascader>
          </div>
          <!-- <div class="filterItem">
            <el-checkbox
              label="提供质保书"
              v-model="SearchData.have_warranty"
              :true-label="1"
              false-label=""
              @change="GetTableList(true)"
            ></el-checkbox>
          </div> -->
        </div>

        <template v-if="TableList.length">
          <div class="quotationContainer">
            <router-link
              v-for="item of TableList"
              :key="item.id"
              :to="'/home/quotation/' + item.code"
              target="_blank"
              class="quotationItem"
            >
              <el-image :src="item.img_array[0]" fit="cover"></el-image>
              <div class="labelList">
                <div v-if="item.character == 1" class="character_1">
                  {{l("正品现货")}}
                </div>
                <div v-else-if="item.character == 2" class="character_2">
                  {{l("二级余料")}}
                </div>
                <div v-else-if="item.character == 3" class="character_2">
                  {{l("正品余料")}}
                </div>
              </div>
              <div class="detail">
                <div class="price one_lines">
                  <template
                    v-if="item.cheap_specification_price.price == '电议'"
                  >
                    {{l("价格电议")}}
                  </template>
                  <template v-else>
                    {{ item.cheap_specification_price.price }}{{l("元")}}/{{
                      item.cheap_specification_price.unit
                    }}
                  </template>
                </div>
                <div class="title one_lines">
                  <img :src="GetResourceUrl('flags/' + item.country.toLowerCase() + '.png')" style="width:20px;vertical-align: middle;" />
                  <span style="vertical-align: middle;margin-left:6px;">{{ item.title }}</span>
                </div>
                <div class="line one_lines">{{l("钢厂")}}：{{ item.steel_mill }}</div>
                <div class="line one_lines">{{l("发货地")}}：
                  {{ item.address }}
                </div>
              </div>
            </router-link>
          </div>

          <el-pagination
            style="justify-content: center; margin: 35px 0"
            background
            @current-change="HandleCurrentChange"
            :current-page="CurrentPage"
            :page-size="PageSize"
            layout="total, prev, pager, next, jumper"
            :total="TotalCount"
          ></el-pagination>
        </template>
        <el-empty
          v-else
          :description="l('抱歉，没有找到你要搜索的产品，试试发布求购信息吧。')"
        >
        </el-empty>
      </div>
      <RecommendQuotationRightBar />
    </div>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
import RecommendQuotationRightBar from "@/components/layout/RecommendQuotationRightBar";

export default {
  name: "HomeQuotation",
  mixins: [tableMixin],
  components: { RecommendQuotationRightBar },
  data() {
    return {
      PageSize: 20,
      SearchData: {
        title: this.$store.state.headerFilter,
        category_id: null,
        child_category: "",
        have_warranty: "",
        character: null,
        address: [],
      },
      // recommendList: [],
      carouselList: [],
    };
  },
  computed: {
    child_categoryList() {
      var category = this.$store.state.basicInfo.categoryList.find(
        (item) => item.id == this.SearchData.category_id
      );
      if (category) {
        return category.child;
      } else {
        return [];
      }
    },
  },
  watch: {},
  created() {
    if (this.$route.query.category_id) {
      this.SearchData.category_id = this.$route.query.category_id;
    }
    if (this.$route.query.child_category) {
      this.SearchData.child_category = this.$route.query.child_category;
    }
    if (this.$route.query.character) {
      this.SearchData.character = this.$route.query.character;
    }
    this.getCarousel();
  },
  mounted() {
    this.$EventBus.$on("headerSearch", ({ filterText }) => {
      this.SearchData.title = filterText;
      this.GetTableList(true);
    });
  },
  beforeDestroy() {
    this.$EventBus.$off("headerSearch");
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;

      this.axios
        .get("/api/visitor_quotation/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results.map((item) => {
            try {
              item.img_array = JSON.parse(item.img_array);
            } catch (e) {
              console.error(e);
            }
            return item;
          });
        });
    },
    getCarousel() {
      this.axios
        .get("/api/banner/", {
          params: {
            position: "carousel_quotation",
            show_pc: true,
            is_show: true,
            i18n: this.$store.state.lang=='zh-CN'?false:true,
          },
        })
        .then((data) => {
          this.carouselList = data;
        });
    },
    clickCarousel(item) {
      if (item.path_pc) {
        if (item.path_pc.indexOf("http") == 0) {
          window.open(item.path_pc);
        } else {
          this.$router.push({ path: item.path_pc });
        }
      }
    },
    cascaderClick(nodeData) {
      this.addrCode = nodeData.name;
      this.$refs.cascader.checkedValue = nodeData.name;
      this.$refs.cascader.computePresentText();
      this.$refs.cascader.toggleDropDownVisible(false);
    },
  },
};
</script>


<style scoped lang="scss">
// .adsBanner {
//   width: 100%;
//   height: 190px;
//   position: relative;
//   overflow: hidden;
//   .el-image {
//     width: 1920px;
//     height: 190px;
//     position: absolute;
//     left: 50%;
//     top: 0;
//     transform: translateX(-50%);
//   }
// }

.carousel {
  // max-width: 1920px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  height: 190px;
  position: relative;
  // margin-top: 15px;
  .el-carousel {
    width: 100%;
    height: 100%;
    /deep/.el-carousel__container {
      height: 100%;
      .el-carousel__item {
        height: 100%;
      }

      .el-carousel__item .el-image {
        height: 100%;
        width: 100%;
      }
    }
  }
}
.mainContainer {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  align-items: flex-start;

  .tableContainer {
    width: 942px;
    .nowFilter {
      display: flex;
      font-size: 14px;
      line-height: 24px;
      height: 24px;
      padding: 12px 0;
      color: #666;
      background: #fff;
      .condition {
        box-sizing: border-box;
        border: 1px solid $borderColor;
        padding: 0 6px;
        margin-right: 15px;
        cursor: pointer;
        &:hover {
          border-color: $warningColor;
          i {
            color: $warningColor;
          }
        }
        span {
          color: $warningColor;
        }
        i {
          cursor: pointer;
        }
      }
      .clearAll {
        margin-left: 20px;
        color: $warningColor;
        cursor: pointer;
      }
    }
    .categoryContainer {
      box-sizing: border-box;
      background: #fff;
      .line {
        display: flex;
        line-height: 42px;
        border-top: 1px solid $borderPlainColor;
        .title {
          background: #f5f5f5;
          width: 84px;
          color: #333;
          text-align: center;
        }
        .category_list {
          display: flex;
          div {
            margin-left: 30px;
            cursor: pointer;
            &:hover {
              color: $warningColor;
            }
            &.active {
              color: $warningColor;
            }
          }
        }
      }
    }
    .orderContainer {
      margin-top: 12px;
      display: flex;
      line-height: 45px;
      text-align: center;
      border: 1px solid $borderPlainColor;
      box-sizing: border-box;
      background: #fff;

      .orderItem {
        // width: 84px;
        box-sizing: border-box;
        padding: 0 18px;
        border-right: 1px solid $borderPlainColor;
        cursor: pointer;
        &.active {
          color: $warningColor;
        }
      }
      .filterItem {
        padding: 0 20px;
        display: flex;
        align-items: center;
        // border-right: 1px solid $borderPlainColor;
        .label {
          margin-right: 10px;
        }
        .el-select, .el-cascader{
          width: 150px !important;
        }
      }
    }

    .quotationContainer {
      display: flex;
      flex-wrap: wrap;
      width: 942px;
      background: #fff;
      margin-top: 15px;
      box-sizing: border-box;
      padding: 16px 12px;
    }
  }

  // .recommendContainer {
  //   width: 240px;
  //   box-sizing: border-box;
  //   border: 1px solid $borderColor;
  //   background: #fff;
  //   .header {
  //     display: flex;
  //     justify-content: space-between;
  //     line-height: 32px;
  //     height: 32px;
  //     padding: 0 10px 2px;
  //     .refresh {
  //       color: #666;
  //       font-size: 12px;
  //       cursor: pointer;
  //       i {
  //         cursor: pointer;
  //       }
  //     }
  //   }
  //   .quotationItem {
  //     width: 220px;
  //     height: 345px;
  //     margin: 0 auto 10px;
  //     .el-image {
  //       width: 220px;
  //       height: 220px;
  //     }
  //   }
  //   .tip {
  //     height: 144px;
  //     color: #9f9f9f;
  //     font-size: 12px;
  //     padding-top: 28px;
  //     box-sizing: border-box;
  //     text-align: center;
  //     .myBtn {
  //       border: 1px solid $warningColor;
  //       color: $warningColor;
  //       width: 96px;
  //       height: 32px;
  //       line-height: 32px;
  //       text-align: center;
  //       font-size: 14px;
  //       margin: 20px auto 0;
  //       cursor: pointer;
  //       &:hover {
  //         color: #fff;
  //         background: $warningColor;
  //       }
  //     }
  //   }
  // }
}

.quotationItem {
  width: 220px;
  height: 338px;
  margin-top: 10px;
  margin-left: 10px;
  cursor: pointer;
  position: relative;
  border: 1px solid $borderPlainColor;
  &:nth-child(4n + 1) {
    margin-left: 0;
  }
  .el-image {
    width: 220px;
    height: 220px;
  }
  .labelList {
    color: #fff;
    position: absolute;
    font-size: 12px;
    text-align: center;
    left: 0;
    top: 0;
    div {
      width: 72px;
      height: 22px;
      line-height: 22px;
      border-bottom-right-radius: 10px;
    }
    .character_1 {
      background: $warningColor;
    }
    .character_2 {
      background: $themeColor;
    }
  }
  .detail {
    margin-top: 6px;
    margin-left: 10px;
    margin-right: 10px;
    .price {
      color: $warningColor;
      font-size: 17px;
      font-weight: bold;
      letter-spacing: 0.5px;
      height: 24px;
      line-height: 24px;
    }
    .title {
      font-size: 15px;
      font-weight: bold;
      line-height: 32px;
      height: 32px;
      margin: 2px 0;
    }
    .line {
      color: #666;
      font-size: 12px;
      height: 20px;
      line-height: 20px;
    }
  }
}

/deep/.el-empty {
  background: #fff;
}
</style>